<template>
  <div>
    <multiselect
      v-model="value"
      :options="accountSegments"
      :input="input"
      :should-close="!showSegment"
      placeholder="Válassz szegmenseket"
      :disabled="loading"
      :spinner="loading"
      :state="state"
      @add="showSegment = true"
    />
    <add-name
      title="Szegmens hozzáadása"
      :show.sync="showSegment"
      :names="segmentNames"
      @add="addSegment"
    />
  </div>
</template>
<script>
import Multiselect from '../Multiselect'
import AddName from './AddName'

export default {
  components: {
    Multiselect,
    AddName
  },
  props: {
    segments: {
      type: Array,
      required: true
    },
    state: {
      type: Boolean,
      validator: prop => typeof prop === 'boolean' || prop === null,
    },
    input: {
      type: Object,
      default: () => ({
        class: 'form-control',
        id: ''
      })
    },
  },
  data() {
    return {
      value: [],
      accountSegments: [],
      showSegment: false,
      loading: true
    }
  },
  computed: {
    segmentNames() {
      return new Set(_.map(this.accountSegments, (segment) => segment.name))
    }
  },
  watch: {
    segments(segments) {
      this.value = segments
    },
    value(value) {
      this.$emit('update:segments', value)
    }
  },
  mounted() {
    this.value = this.segments
    this.$http.get(this.$url('api.segments.index'))
      .then(response => {
        if(response.data && response.data.segments) {
          this.accountSegments = response.data.segments
        }
      }).catch(error => {
        console.log(error) // eslint-disable-line
      }).finally(() => {
        this.loading = false
      })
  },
  methods: {
    addSegment(name = '') {
      var maxSegmentId = _.maxBy(this.accountSegments, (segment) => segment.id).id
      var newSegment = {
        id: maxSegmentId + 1,
        new: true,
        name: name,
      }

      this.accountSegments.push(newSegment)
      this.value.push(newSegment)
    },
  }
}
</script>